import { Injectable } from '@angular/core';
import {
  HttpClient,
  HttpEvent,
  HttpEventType,
  HttpRequest,
  HttpResponse,
} from '@angular/common/http';
import { SETTINGS } from '../config/common.settings';
import { NzUploadXHRArgs } from 'ng-zorro-antd/upload';
import { BehaviorSubject, Observable, Subject, Subscription } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class UploadService {
  onUploadedFileChange: Subject<any> = new BehaviorSubject(null);

  constructor(private http: HttpClient) {}

  uploadFile(formData: any, item: NzUploadXHRArgs | any): Subscription {
    const req = new HttpRequest(
      'POST',
      `${SETTINGS.BASE_API}/files/upload`,
      formData,
      {
        reportProgress: true,
        withCredentials: false,
      }
    );
    return this.http.request(req).subscribe({
      next: (event: HttpEvent<{}> | any) => {
        if (event.type === HttpEventType.UploadProgress) {
          if (event.total > 0) {
            (event as any).percent = (event.loaded / event.total) * 100;
          }
          item.onProgress(event, item.file);
        } else if (event instanceof HttpResponse) {
          this.onUploadedFileChange.next(event.body);
          item.onSuccess(event.body, item.file, event);
        }
      },
      error: (err: any) => {
        item.onError(err, item.file);
      },
    });
  }
  downloadFile(fileName: string): Observable<Blob> {
    return this.http.post(
      `${SETTINGS.BASE_API}/files/download`,
      {
        fileName,
      },
      {
        responseType: 'blob',
        headers: { 'Access-Control-Allow-Origin': '*' },
      }
    );
  }
}
